import React from 'react';
import { Modal, View, Text, TouchableOpacity, StyleSheet, Dimensions, Platform } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const { width } = Dimensions.get('window');

export default function CustomAlert({ 
  visible, 
  title, 
  message, 
  type = 'info', 
  onConfirm, 
  onCancel, 
  confirmText = "Tamam", 
  cancelText = "Vazgeç",
  showCancel = false 
}) {
  
  const getIcon = () => {
    switch (type) {
      case 'success': return { name: 'checkmark-circle', color: '#10b981' };
      case 'error': return { name: 'alert-circle', color: '#ef4444' };
      case 'warning': return { name: 'warning', color: '#f59e0b' };
      default: return { name: 'information-circle', color: '#2563eb' };
    }
  };

  const icon = getIcon();

  const renderMessage = () => {
    if (!message) return null;
    const parts = message.split(/(\*.*?\*)/g);
    return (
      <Text style={styles.message}>
        {parts.map((part, index) => {
          if (part.startsWith('*') && part.endsWith('*')) {
            return (
              <Text key={index} style={styles.boldHighlight}>
                {part.replace(/\*/g, '')}
              </Text>
            );
          }
          return part;
        })}
      </Text>
    );
  };

  const alertContent = (
    <View style={styles.alertBox}>
      <View style={[styles.iconContainer, { backgroundColor: icon.color + '15' }]}>
        <Ionicons name={icon.name} size={40} color={icon.color} />
      </View>
      <Text style={styles.title}>{title}</Text>
      {renderMessage()}
      <View style={styles.buttonRow}>
        {showCancel && (
          <TouchableOpacity style={styles.cancelBtn} onPress={onCancel}>
            <Text style={styles.cancelBtnText}>{cancelText}</Text>
          </TouchableOpacity>
        )}
        <TouchableOpacity 
          style={[styles.confirmBtn, { backgroundColor: icon.color }]} 
          onPress={onConfirm}
        >
          <Text style={styles.confirmBtnText}>{confirmText}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );

  // Web için tamamen farklı yaklaşım - doğrudan HTML/CSS
  if (Platform.OS === 'web') {
    if (!visible) return null;
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999999,
      }}>
        {alertContent}
      </div>
    );
  }

  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={styles.overlay}>
        {alertContent}
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: { 
    flex: 1, 
    backgroundColor: 'rgba(0,0,0,0.5)', 
    justifyContent: 'center', 
    alignItems: 'center' 
  },
  alertBox: { 
    width: width * 0.85, 
    maxWidth: 400,
    backgroundColor: 'white', 
    borderRadius: 24, 
    padding: 25, 
    alignItems: 'center', 
    elevation: 20,
  },
  iconContainer: { width: 80, height: 80, borderRadius: 40, justifyContent: 'center', alignItems: 'center', marginBottom: 20 },
  title: { fontSize: 20, fontWeight: '800', color: '#1e293b', marginBottom: 10, textAlign: 'center' },
  message: { fontSize: 14, color: '#64748b', textAlign: 'center', lineHeight: 22, marginBottom: 25 },
  boldHighlight: { fontWeight: '900', color: '#0f172a' },
  buttonRow: { flexDirection: 'row', width: '100%', gap: 10 },
  confirmBtn: { flex: 1, height: 50, borderRadius: 15, justifyContent: 'center', alignItems: 'center' },
  confirmBtnText: { color: 'white', fontWeight: '700', fontSize: 15 },
  cancelBtn: { flex: 1, height: 50, borderRadius: 15, justifyContent: 'center', alignItems: 'center', backgroundColor: '#f1f5f9' },
  cancelBtnText: { color: '#64748b', fontWeight: '700', fontSize: 15 },
});